import { Box } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { BlockingIssuesCallout } from 'modules/integrations/components/SyncButton/Modals/BlockingIssuesModal/BlockingIssueCallout'
import { BlockingIssue } from 'modules/integrations/hooks/SyncContext/blockingIssues'

type BlockingIssuesModalProps = {
  onClose: () => void
  blockingIssues: BlockingIssue[]
}

export function BlockingIssuesModal({ onClose, blockingIssues }: BlockingIssuesModalProps) {
  return (
    <Modal
      illustration="upload"
      title={i18n.t('compensations.integrations.sync_validations.blocking_issues.modal_title')}
      onClose={onClose}
    >
      <Box gap="s32" width="s600">
        {blockingIssues.map((issue, index) => (
          <BlockingIssuesCallout blockingIssue={issue} key={index} />
        ))}
      </Box>
    </Modal>
  )
}
